import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import DataTable from '../../components/admin/DataTable';
import api from '../../utils/api';
import './PaymentListPage.css';

const PaymentListPage = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    try {
      const res = await api.get('/payments');
      setPayments(res.data);
    } catch (error) {
      console.error('Failed to fetch payments:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      await api.patch(`/payments/${id}/status`, { status: newStatus });
      fetchPayments();
    } catch (error) {
      console.error('Failed to update payment status:', error);
    }
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'bookingId', label: 'Booking ID' },
    {
      key: 'amount',
      label: 'Amount',
      render: (row) => `${row.amount?.toLocaleString()} ${row.currency}`,
    },
    {
      key: 'status',
      label: 'Status',
      render: (row) => (
        <select
          className={`status-select ${row.status.toLowerCase()}`}
          value={row.status}
          onChange={(e) => handleStatusChange(row.id, e.target.value)}
        >
          <option value="PENDING">Pending</option>
          <option value="PAID">Paid</option>
          <option value="REFUNDED">Refunded</option>
          <option value="FAILED">Failed</option>
        </select>
      ),
    },
    { key: 'paymentMethod', label: 'Method', render: (row) => row.paymentMethod || '-' },
    { key: 'paidAt', label: 'Paid At', render: (row) => row.paidAt ? new Date(row.paidAt).toLocaleString() : '-' },
    { key: 'createdAt', label: 'Created', render: (row) => row.createdAt ? new Date(row.createdAt).toLocaleString() : '-' },
  ];

  if (loading) {
    return <AdminLayout><div className="admin-loading">Loading...</div></AdminLayout>;
  }

  return (
    <AdminLayout>
      <div className="payment-list-page">
        <h1>Payments</h1>
        <DataTable columns={columns} data={payments} emptyMessage="No payments found" />
      </div>
    </AdminLayout>
  );
};

export default PaymentListPage;
